// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"cd983630","31":"5a266ea7","395":"d186df89","530":"fc5c9e80","549":"679236dc","567":"d514eff2","696":"f4d36cf1","756":"92c71758"}[chunkId] + ".chunk.js";
};